import { Network } from 'alchemy-sdk'

type TDefineAlchemyNetwork = (
  chainId: number | null
) => Network | void

const defineAlchemyNetwork: TDefineAlchemyNetwork = (
  chainId
) => {
  if (!chainId) {
    return
  }
  
  switch (Number(chainId)) {
    case 1:
      return Network.ETH_MAINNET
    case 5:
      return Network.ETH_GOERLI
    case 10:
      return Network.OPT_MAINNET
    case 42161:
      return Network.ARB_MAINNET
    case 137:
      return Network.MATIC_MAINNET
    case 11155111:
      return Network.ETH_SEPOLIA
    case 8453:
      return Network.BASE_MAINNET
    case 84531:
      return Network.BASE_GOERLI
    default:
      return
  }
}

export default defineAlchemyNetwork